import { render, staticRenderFns } from "./CustomChart.vue?vue&type=template&id=04aed0b8&"
import script from "./CustomChart.vue?vue&type=script&lang=ts&"
export * from "./CustomChart.vue?vue&type=script&lang=ts&"
import style0 from "./CustomChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports